module.exports = __webpack_public_path__ + "static/media/r178.a519863c.jpg";